module.exports = __webpack_public_path__ + "49068eced5732db2d69abf416d2ec28e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PS.svg
// module id = eCmc
// module chunks = 0